import React, { useEffect, useRef, useState } from 'react';
import "./styleComplaints.css";
import INCSUBSearchbar from '../../components/common/SearchBar/INCSUBSearchbar';
import { getComplaintList } from '../../services/complaintServices';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router';
import { constant } from 'lodash';
import INCSUBFilterList from '../../components/common/filter/FilterList';
import { useDispatch, useSelector } from 'react-redux';
import { setComplaintList, setComplaintRoute, setSelectedComplaint } from '../../features/complaints/complaintsSlice';
import INCSUBComplaintsDetails from './complaintDetails/ComplaintsDetails';
import ReactPaginate from 'react-paginate';

function INCSUBComplaints() {
    const navigate = useNavigate();
    const [searchKey, setSearchKey] = useState('')
    const [complaintType, setComplaintType] = useState('All');
    const [status, setStatus] = useState('All');
    const [userType, setUserType] = useState("All");
    const complaintList = useSelector((state) => state.complaint.complaintList)
    const [pageNo, setPageNo] = useState(0);
    const [shimmer, setShimmer] = useState(false);
    const complaintRoute = useSelector((state) => state.complaint.complaintRoute);
    const dispatch = useDispatch();
    const statusList = [{
        id: 'All',
        name: 'All'
    },
    {
        id: 'Open',
        name: 'Open'
    },
    {
        id: 'Close',
        name: 'Close'
    }]
    const complaintTypeList = [{
        id: 'All',
        name: 'All'
    },
    {
        id: 'Refund',
        name: 'Refund'
    },
    {
        id: 'General',
        name: 'General',
    }, {
        id: 'Onboarding',
        name: 'Onboarding'
    },
    {
        id: 'Verification',
        name: 'Verification'
    },
    {
        id: 'Payouts',
        name: 'Payouts'
    },
    {
        id: 'Credential',
        name: 'Credential'
    }]
    const userTypeList = [{
        id: 'All',
        name: 'All'
    },
    {
        id: 'Host',
        name: 'Host'
    },
    {
        id: 'User',
        name: 'User'
    }, {
        id: 'Host+User',
        name: 'Host+User'
    }]




    /*@Author govind dindewad
    Below function is for fetch complaints data from server
    in below function called getComplaintList() function to call api and stored data to redux store
    and also handled a error validations
    */
    const fetchComplaintData = async ({
        searchKeyState = searchKey,
        userTypeState = userType,
        statusState = status,
        complaintTypeState = complaintType,
        pageNoState = pageNo
    } = {}) => {
        setShimmer(true)
        try {
            const complaintData = await getComplaintList({ searchKey: searchKeyState, complaintType: complaintTypeState, status: statusState, userType: userTypeState, pageNo: pageNoState });
            if (complaintData.status === 200) {
                dispatch(setComplaintList(complaintData.data.data))
            } else if (complaintData.status === 301) {
                toast.error("Network Error");
            } else if (complaintData.status === 500) {
                toast.error("Internal Server Error");
            } else if (complaintData.status === 401) {
                navigate('/login');
            } else if (![200, 401].includes(complaintData.status)) {
                toast.error(complaintData.data.message)
            }
        } catch (error) {
            toast.error("Something went wrong")
        } finally {
            setShimmer(false)
        }
    }

    const formatDateTime = (dateTime) => {
        const date = new Date(dateTime);
        const options = { day: "2-digit", month: "short", year: "numeric" };
        const formattedDate = date.toLocaleDateString("en-GB", options).replace(",", "");
        const hours = date.getHours();
        const minutes = date.getMinutes().toString().padStart(2, "0");
        const period = hours >= 12 ? "PM" : "AM";
        const formattedTime = `${hours % 12 || 12}:${minutes} ${period}`;

        return `${formattedDate} ${formattedTime}`;
    };


    useEffect(() => {

        // if (!complaintList) {
        /*calling once after render a file*/
        fetchComplaintData();
        // }
    }, [])



    /*@@govind dindewad
to handle filter of user type for complaints
*/
    const handleUserTypeChange = (userType) => {
        setUserType((prevStatus) => {
            const newType = userType.name;
            fetchComplaintData({ userTypeState: newType }); // Pass the updated state if needed
            return newType;
        });

    }

    /*@@govind dindewad
  to handle filter of complaint type for complaints
  */
    const handleComplaintTypeChange = (complaintType) => {
        setComplaintType((prevStatus) => {
            const newType = complaintType.name;
            fetchComplaintData({ complaintTypeState: newType }); // Pass the updated state if needed
            return newType;
        });

    }


    /*@@govind dindewad
    to handle filter of status for complaints
    */
    const handleStatusChange = (status) => {
        setStatus((prevStatus) => {
            const newStatus = status.name;
            fetchComplaintData({ statusState: newStatus }); // Pass the updated state if needed
            return newStatus;
        });

    }

    /*@@govind dindewad
        to handle search for complaint list
    */
    const handleSearch = (key) => {
        // fetchComplaintData({ searchKeyState: searchKey })
        setSearchKey((prevSearch) => {
            const newSearch = key;
            fetchComplaintData({ searchKeyState: newSearch }); // Pass the updated state if needed
            return newSearch;
        });
    }


    const handleRouteDetails = () => {
        dispatch(setComplaintRoute('/complaints/complainDetails'))
    }



    const [currentPage, setCurrentPage] = useState(0);
    function PaginatedItems() {
        const [itemOffset, setItemOffset] = useState(2);
        const endOffset = itemOffset;

        const pageCount = complaintList ? complaintList.totalPages : 0;
        // Invoke when user click to request another page.
        const handlePageClick = (event) => {
            setPageNo(event.selected);
            fetchComplaintData({ pageNoState: event.selected })
            setCurrentPage(event.selected)
            setItemOffset(event.selected);
        };


        return (

            <div className='INCSUBComplaints_list_section_container'>{
                !shimmer && complaintList && complaintList.complaintsDetailsDtoList && complaintList?.complaintsDetailsDtoList.length > 0 && pageCount > 1 ? <ReactPaginate
                    breakLabel="..."
                    nextLabel="next >"
                    onPageChange={handlePageClick}
                    pageRangeDisplayed={5}
                    pageCount={pageCount}
                    previousLabel="< previous"
                    renderOnZeroPageCount={null}
                    pageClassName="page-item"
                    pageLinkClassName="page-link"
                    previousClassName="page-item"
                    previousLinkClassName="page-link"
                    nextClassName="page-item"
                    nextLinkClassName="page-link"
                    breakClassName="page-item"
                    breakLinkClassName="page-link"
                    containerClassName="pagination"
                    activeClassName="active"
                    forcePage={currentPage}
                /> : null
            }



            </div>


        );
    }


    return (
        <div className='INCSUBComplaints'>{
            complaintRoute === "/complaints" ?
                <div className='INCSUBComplaint_container'>
                    <div className='INCSUBComplaint_filter_section'>
                        <div className="INCSUBPools_Search_filters_container">
                            <INCSUBSearchbar source={'complaints'} placeholder={'Search'} param={{ pageNumber: pageNo, func: handleSearch }} />
                            <INCSUBFilterList list={statusList} value={status} func={handleStatusChange} type={"Status"} />
                            <INCSUBFilterList list={complaintTypeList} value={complaintType} func={handleComplaintTypeChange} type={"Complaint Type"} />
                            <INCSUBFilterList list={userTypeList} value={userType} func={handleUserTypeChange} type={"User Type"} />
                        </div>
                    </div>

                    <div className='INCSUBComplaint_userlist_section'>
                        <div className='INCSUBUser_userlist_section_table_conatiner'>
                            {shimmer ?
                                <div>
                                    <div className="animate-pulse">
                                        <div className="border border-gray-200 rounded-lg overflow-hidden">
                                            <div className="flex bg-gray-100 py-2 px-4">
                                                <div className="w-1/12 h-6 bg-gray-300 rounded mr-2"></div>
                                                <div className="w-2/12 h-6 bg-gray-300 rounded mr-2"></div>
                                                <div className="w-3/12 h-6 bg-gray-300 rounded mr-2"></div>
                                                <div className="w-2/12 h-6 bg-gray-300 rounded mr-2"></div>
                                                <div className="w-2/12 h-6 bg-gray-300 rounded mr-2"></div>
                                                <div className="w-2/12 h-6 bg-gray-300 rounded"></div>
                                            </div>
                                            {Array(12).fill(0).map((_, index) => (
                                                <div key={index} className="flex py-2 px-4">
                                                    <div className="w-1/12 h-6 bg-gray-300 rounded mr-2"></div>
                                                    <div className="w-2/12 h-6 bg-gray-300 rounded mr-2"></div>
                                                    <div className="w-3/12 h-6 bg-gray-300 rounded mr-2"></div>
                                                    <div className="w-2/12 h-6 bg-gray-300 rounded mr-2"></div>
                                                    <div className="w-2/12 h-6 bg-gray-300 rounded mr-2"></div>
                                                    <div className="w-2/12 h-6 bg-gray-300 rounded"></div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div> :
                                (complaintList && complaintList.complaintsDetailsDtoList.length > 0 ? <table className='INCSUBuser_table'>
                                    <thead className='INCSUBuser_table_head'>
                                        <tr>
                                            <th>#</th>
                                            <th>Type</th>
                                            <th>Complaints</th>
                                            <th>Submitted from</th>
                                            <th>Mobile No.</th>
                                            <th>Submitted Date</th>
                                            <th>Status</th>
                                            <th>Closing date</th>
                                        </tr>
                                    </thead>
                                    <tbody className='INCSUBuser_table_body'>
                                        {
                                            complaintList && complaintList.complaintsDetailsDtoList.length > 0 && complaintList.complaintsDetailsDtoList.map((complaint, index) =>
                                                <tr onClick={() => {
                                                    handleRouteDetails();
                                                    dispatch(setSelectedComplaint(complaint));
                                                }
                                                }>
                                                    <td>{index + 1}</td>
                                                    <td className={complaint?.complaintType} style={{ color: "rgba(61, 66, 223, 1)" }}>{complaint?.complaintType}</td>
                                                    <td>{complaint?.complaintTitle}</td>
                                                    <td><div className='INCSUBprofile_name_container'>
                                                        <div className='INCSUBProfile_image_holder'>
                                                            <img src={complaint.complaintSubmittedFromImage ? complaint.complaintSubmittedFromImage : '/assets/icons/common/defaultImage.png'} alt='/' />
                                                        </div>
                                                        <div className='name_conatiner'>
                                                            <div className='name'>{complaint?.complaintSubmittedFrom}</div>
                                                            <div className='mobile_no'>{complaint?.complaintSubmittedFromUserType}</div>
                                                        </div>
                                                    </div></td>
                                                    <td>{complaint?.mobileNumber}</td>
                                                    <td>{complaint?.complaintSubmittedDate ? formatDateTime(complaint?.complaintSubmittedDate) : ""}</td>
                                                    <td><div className={`INCSUBComplaint_status ${complaint?.complaintStatus}`}>{complaint?.complaintStatus}</div></td>
                                                    <td>{complaint?.complaintClosingDate ? formatDateTime(complaint?.complaintClosingDate) : ''}</td>

                                                </tr>)
                                        }

                                    </tbody>
                                </table> : <div className='INCSUBComplaint_empty'>No Complaints available</div>)
                            }

                        </div>
                    </div>


                    <PaginatedItems />
                </div> : <INCSUBComplaintsDetails />
        }

        </div>
    )
}

export default INCSUBComplaints
